export default __webpack_public_path__ + "static/media/1966.9309af34.png";